export interface IPagination {
  page: number
  pagesize: number
  page_count: number
  count?: number
}

export type Pagination<D> = D & {
  pagination: IPagination
}

export const defaultPageSize = 20

export function asMissEvanPagination(data: any): IPagination {
  return {
    page: data.p ? parseInt(data.p) : 1,
    page_count: data.maxpage ? parseInt(data.maxpage) : 1,
    pagesize: data.pagesize ? parseInt(data.pagesize) : defaultPageSize,
    count: data.count ? parseInt(data.count) : 0,
  }
}
